export var IProductPageLayoutRequest;
(function (IProductPageLayoutRequest) {
    let GridSize;
    (function (GridSize) {
        GridSize["GRID_SIZE_UNKNOWN"] = "GRID_SIZE_UNKNOWN";
        /**
         * Desktop is default in BE logic.
         */
        GridSize["DESKTOP"] = "DESKTOP";
        /**
         * Mobile-size view will render less tiles.
         */
        GridSize["MOBILE"] = "MOBILE";
    })(GridSize = IProductPageLayoutRequest.GridSize || (IProductPageLayoutRequest.GridSize = {}));
    /**
     * Desktop has two layout sessions, part of a collection banner and bottom layout elements
     */
    let LayoutSession;
    (function (LayoutSession) {
        LayoutSession["LAYOUT_SESSION_UNKNOWN"] = "LAYOUT_SESSION_UNKNOWN";
        LayoutSession["PART_OF_A_COLLECTION"] = "PART_OF_A_COLLECTION";
        LayoutSession["BOTTOM"] = "BOTTOM";
    })(LayoutSession = IProductPageLayoutRequest.LayoutSession || (IProductPageLayoutRequest.LayoutSession = {}));
    /**
     * Return an instance of IProductPageLayoutRequest with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IProductPageLayoutRequest.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IProductPageLayoutRequest || (IProductPageLayoutRequest = {}));
